import React from 'react';
import PropTypes from 'prop-types';
import ElidedText from '../ElidedText';
import {CARD_TYPE_CNAME} from '../../common/constants';

import './Title.less';

const TITLE_CNAME = `${CARD_TYPE_CNAME}__title`;

const Title = ({children}) => {
    if (!children) {
        return null;
    }

    return (
        <ElidedText>
            <h4 className={TITLE_CNAME}>{children}</h4>
        </ElidedText>
    );
};

export default Title;

Title.propTypes = {
    children: PropTypes.string,
};
